import * as React from 'react';
import {useTranslation} from 'react-i18next';
import {useNavigate} from 'react-router-dom';
import {Button, Space, Typography} from 'antd';
import {AuthFormContainer} from 'components/AuthFormContainer';
import {AuthRoutePaths} from 'routing/Routes';
import {appState} from 'store/AppStore';

export const EmailCheckResetLinkView: React.FC = () => {
  const navigate = useNavigate();
  const {t} = useTranslation();
  const {authState} = appState;

  return (
    <AuthFormContainer>
      <Space direction="vertical" className="w-80">
        <Typography.Title className="text-3xl mb-3">{t('Check your email')}</Typography.Title>
        <Typography.Paragraph className="text-left text-darkGray mb-12">
          {t('We have sent en email to ')}
          <Typography.Text type="secondary">{authState.resetPasswordEmail}</Typography.Text>
          {t(
            ', which contains a link to reset your password. Please check your inbox, click the link and reset your password. Remember to check spam.'
          )}
        </Typography.Paragraph>
        <Button type="primary" block onClick={() => navigate(AuthRoutePaths.signIn.url)}>
          {t('Go to sign in page')}
        </Button>
        <Typography.Text>
          {t('Didn’t receive the link? ')}
          <Button
            type="link"
            className="px-0"
            onClick={() => authState.sendResetLink({email: authState.resetPasswordEmail})}
          >
            {t('Resend')}
          </Button>
        </Typography.Text>
      </Space>
    </AuthFormContainer>
  );
};
